import _ from 'lodash';
import pluginsList from 'view/audioTracker/plugins/plugins-list';

export default {
	computed: {
		
	},
	data() {
		return {
			pluginsBankVisible: false,
			selectedPluginsBank: null,
		}
	},
	methods: {
		openPluginBanksFor(postEffects) {
			this.focusedAggregatedTrack = null;
			this.pluginsBankVisible = false;
			this.selectedPluginsBank = null;
			setImmediate(() => {
				this.pluginsBankVisible = true;
			})
			if (__DEBUG__)
				console.debug('Open plugin and effect banks for', { postEffects });
		},			
		async applyPluginsBank(aggregatedTrack) {
			if (__DEBUG__)
				console.debug('Apply plugin banks', { bank: this.selectedPluginsBank, aggregatedTrack });
			this.pluginsBankVisible = false;
			let bank = await this.$Data.getExternalApi('Creative/GetTemplateInsertion', `insertionId=${this.selectedPluginsBank?.Oid}`, 1, true);
			let bankPostEffects = bank?.JsonConfig?.postEffects;
			if (__DEBUG__)
				console.debug('Plugin banks loaded', { bank, aggregatedTrack });

			if (aggregatedTrack) {
				if (bank.JsonConfig?.postEffects) {
					aggregatedTrack.postEffects = _.cloneDeep(bank.JsonConfig.postEffects);
				}
				aggregatedTrack.wapiPlugins = _.cloneDeep(bank.JsonConfig?.wapiPlugins || []);
				aggregatedTrack.selectedPluginBank = this.selectedPluginsBank?.Oid;
				
				if (bank?.JsonConfig?.normalize?.enabled) {
					aggregatedTrack.normalize = _.cloneDeep(bank?.JsonConfig?.normalize);
				}
			} else {
				if (bank.JsonConfig.postEffects?.plugins?.length) {
					this.$set(this.creative.JsonConfig.masterTrackConfig, 'postEffects', _.cloneDeep(bank.JsonConfig.postEffects));
				}
				if (bank.JsonConfig.wapiPlugins?.length) {
					this.$set(this.creative.JsonConfig.masterTrackConfig, 'wapiPlugins', _.cloneDeep(bank.JsonConfig.wapiPlugins));
				}
			}

		},
		getActiveWapiPlugin(aggTrack, pluginId) {
			return aggTrack.wapiPlugins.find(f => f.id === pluginId && f.enabled) || aggTrack.wapiPlugins.find(f => f.id === pluginId);
		},
		infoPanelActionsWAPIPlugins(track) {
			var pluginSource = pluginsList.plugins[0];
			if (!pluginSource) return null;

			let plugin = this.getActiveWapiPlugin(track.__aggregatedTrack, pluginSource.id);

			return [{
				id: `wapiPlugin_${pluginSource.id}`,
				name: pluginSource.name(),
				icon: `${pluginSource.icon || 'fas fa-microchip'}`,
				active: plugin?.enabled || false
			}]
		},
	}
};
